import { useMutation } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase/client';

interface Input {
  token: string;
  password: string;
}

export function useAcceptInvite() {
  return useMutation({
    mutationFn: async ({ token, password }: Input) => {
      const { data, error } = await supabase.functions.invoke('accept-b2b-invite', {
        body: { invite_token: token, password },
      });

      // Even on non-2xx, Supabase puts the JSON body on `data` for us to read.
      if (data?.error) throw new Error(data.details ?? data.error);
      if (error) throw new Error(error.message ?? 'Failed to accept invite');
      if (!data) throw new Error('Empty response from accept-invite');

      const email = data.email as string | undefined;
      if (!email) throw new Error('Missing email in response');

      const { error: signInErr } = await supabase.auth.signInWithPassword({ email, password });
      if (signInErr) throw new Error(signInErr.message ?? 'Failed to sign in');

      return { email };
    },
  });
}
